import { AZURE_STORAGE_PREFIX } from "constant/env-variables";

function getVideoMediaKeys(itemValue) {
  const mediaKeys = [itemValue];

  if (typeof itemValue === "string") {
    try {
      const parsedValue = JSON.parse(itemValue);
      if (parsedValue && typeof parsedValue === "object") {
        mediaKeys.length = 0;
        if (parsedValue.video) mediaKeys.push(parsedValue.video);
        if (parsedValue.thumbnail) mediaKeys.push(parsedValue.thumbnail);
      }
    } catch (e) {
      // Keep original value when itemValue is a plain UUID/string.
    }
  }

  return mediaKeys.filter(Boolean);
}

/**
 * Build the payload for POST /base/duplicate_media when copying graphic/video
 * assets from a template document folder to a target document folder.
 *
 * @returns {Array<{ from: string, to: string }>}
 */
export function buildTemplateLayoutMediaDuplicates({
  templateDocumentId,
  targetDocumentId,
  layoutData,
  tenantId
}) {
  if (!templateDocumentId || !targetDocumentId || !layoutData?.layout?.length || !tenantId) {
    return [];
  }

  const items = layoutData.items || {};
  const graphicItems = layoutData.layout.filter((l) => l.typeId === "graphic");
  const videoItems = layoutData.layout.filter((l) => l.typeId === "video");

  const graphicMedias = graphicItems
    .map((item) => {
      const itemValue = items[item.i];
      if (!itemValue) return null;
      return {
        from: `${AZURE_STORAGE_PREFIX}/${tenantId}/documents/${templateDocumentId}/${itemValue}`,
        to: `${AZURE_STORAGE_PREFIX}/${tenantId}/documents/${targetDocumentId}/${itemValue}`
      };
    })
    .filter(Boolean);

  const videoMedias = videoItems.flatMap((item) => {
    const itemValue = items[item.i];
    if (!itemValue) return [];
    return getVideoMediaKeys(itemValue).map((mediaKey) => ({
      from: `${AZURE_STORAGE_PREFIX}/${tenantId}/documents/${templateDocumentId}/${mediaKey}`,
      to: `${AZURE_STORAGE_PREFIX}/${tenantId}/documents/${targetDocumentId}/${mediaKey}`
    }));
  });

  return [...graphicMedias, ...videoMedias];
}
